var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentityProof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1700_4518)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.2319,
    r: 19.5455,
    fill: "#fbfbfb",
    stroke: "#C1C5CF",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4526,
    y: 10.144,
    width: 17.0947,
    height: 20.1758,
    rx: 0.853841,
    stroke: "#F9009E",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 26L15.0002 24.1248C15.0003 23.0893 15.8398 22.25 16.8752 22.25H20.6249M22.1875 23.8125L22.8125 24.4375L25 22.25M22.8125 16C23.571 16.4251 24.0625 17.1067 24.0625 17.875C24.0625 18.6433 23.571 19.3249 22.8125 19.75M21.25 17.875C21.25 18.9105 20.4105 19.75 19.375 19.75C18.3395 19.75 17.5 18.9105 17.5 17.875C17.5 16.8395 18.3395 16 19.375 16C20.4105 16 21.25 16.8395 21.25 17.875Z",
    stroke: "#F9009E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1700_4518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.231873)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityProof);
export default __webpack_public_path__ + "static/media/IdentityProof.4f8fe3559a8d0e5005227a7a8fcea98f.svg";
export { ForwardRef as ReactComponent };